import { FC } from 'react';
import { WebCitation } from '@/types/assistant';

interface Props {
  citation: WebCitation;
}

function hostname(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}

/** Chip de citação web (G06) — clique abre a fonte em nova aba (`noopener`). */
const CitationChip: FC<Props> = ({ citation }) => {
  const label = citation.title?.trim() || hostname(citation.url);

  return (
    <a
      data-testid="citation-chip"
      href={citation.url}
      target="_blank"
      rel="noopener noreferrer"
      title={citation.snippet || citation.url}
      className="inline-flex items-center gap-1.5 text-2xs px-2.5 py-1 rounded-full bg-surface-tertiary border border-surface-border text-content-secondary hover:border-accent hover:text-accent transition max-w-[220px]"
    >
      <span className="material-symbols-outlined text-[13px] leading-none">public</span>
      <span className="truncate">{label}</span>
    </a>
  );
};

export default CitationChip;
